import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { DialogService } from '../../../dialog/dialog.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { DashboardService } from '../../services/dashboard.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { HttpCacheService } from 'src/modules/base/shared/services/http-cache.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
// import { DialogService } from '../../../../Components/dialog/dialog.service';
// import { AlertsService } from '../../../../services/alerts.service';
// import { AppService } from '../../../../services/app.service';
// import { BaseService } from '../../../../services/base.service';
// import { LoaderService } from '../../../../services/loader.service';
// import { StorageService } from '../../../../services/storage.service';
// import { UtilService } from '../../../../services/util.service';
// // import { TrackerReminderService } from '../../../../../tracker-reminder/tracker-reminder.service';
// import moment from 'proxies/dayjs';
// import { DashboardService } from '../../services/dashboard.service';
// import { AuthenticationService } from '../../../../services/authentication.service';
// import { CacheService } from '../../../../services/cache.service';

@Component({
    selector: 'track-health-vitals',
    templateUrl: './track-health-vitals.component.html',
    styleUrls: ['./track-health-vitals.component.scss'],
    standalone: false
})
export class TrackHealthVitalsComponent implements OnInit {
  @Input() data: any;
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  vitalVal: any = "";
  imgUrl: any = "";
  widgetName: string = "";
  config: any = {};

  sleep_record: any = {};
  yoga_record: any = {};
  exercise_record: any = {};
  meditation_record: any = {};
  showSkeletonLoader = true;
  height: string;
  constructor(private appService: AppService,
    private loader: LoaderService,
    public router: Router,
    public dialogService: DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService: UtilService,
    public dashBoardService: DashboardService,
    public authenticationService: AuthenticationService,
    public appservice: AppService,
    //public cacheService: HttpCacheService,
    public baseService: BaseService) {

  }


  ngOnInit() {
    this.build();
    if (this.utilService.isMobile()) {
      this.height = '87px'
     } else {
      this.height = '160px'
  
     }


  }

  build() {
    // this.loader.showSpinner();
    let id = this.data.widget_id || this.data.slider_id;
    //if(this.cacheService.checkWidget( 'track-health-vitals', id)) {
    this.dashBoardService.getWidgetData(id, (data) => {
      if (data) {
     // this.cacheService.setWidgetStorage('track-health-vitals', data);

        if (this.utilService.isMobile()) {
          if (data.mobile_document_code) {
            this.imgUrl = `assets/webflow-images/dashboard/${data.mobile_document_code}`;
          }
        } else {
        if (data.document_code) {
          this.imgUrl = `assets/webflow-images/dashboard/${data.document_code}`;
        }
      }
        this.config['data'] = data;
        //this.getVitals(data);

        this.widgetName = data.widget_name;

      }
      // this.loader.hideSpinner();
      this.showSkeletonLoader = false;
    })
  } 
  // else {
  //   this.cacheService.getWidget().subscribe(value => {
  //     const List = value.filter(ele => ele['track-health-vitals']);
  //     const configData = List.filter(ele => ele['track-health-vitals'].id === id)
  //     this.config.data = configData && configData.length > 0 ? configData[0]['track-health-vitals'] : '';
  //     if (this.utilService.isMobile()) {
  //       if (this.config.data.mobile_document_code) {
  //         this.imgUrl = `assets/webflow-images/dashboard/${this.config.data.mobile_document_code}`;
  //       }
  //     } else {
  //     if (this.config.data.document_code) {
  //       this.imgUrl = `assets/webflow-images/dashboard/${this.config.data.document_code}`;
  //     }
  //   }
  //     this.getVitals(this.config.data);

  //     this.widgetName = this.config.data.widget_name;

  //      this.showSkeletonLoader = false;
  //   })
  // }
  //}

  handleLinkClick() {
    this.router.navigateByUrl(this.config.data.link);
  }
  // getVitals(data) {
  //   let obj = { filter: 'userId:' + this.authenticationService.getCurrentUser().user_id + ",uhId:" + localStorage.getItem("hasUhId") + ",cug_code:" + this.appservice != undefined && this.appservice._currentSessionData != undefined && this.appservice._currentSessionData.cug_code != undefined ? this.appservice._currentSessionData.cug_code : '' };
  //   this.baseService.getData(obj, '', "emr_vitals", "diagnostic", "GET_ALL").subscribe(val => {
  //     if (val) {
  //       {
  //         this.loader.hideSpinner();
  //         let res = val;
  //         if (res.errCode == 0) {
  //           if (res.resource.length > 0) {
  //             let bpdata: Array<any> = res.resource;
  //             for (let index = 0; index < bpdata.length; index++) {
  //               let vitalname: Array<any> = bpdata[index].vitalsName;
  //               let vital = this.setVitals(vitalname, data);
  //               if (vital != undefined) {
  //                 break;
  //               }
  //             }
  //           }
  //         }
  //       }

  //     }
  //   })
  // }

  // formatActivityData(activityData: any[]): any[] {
  //   const formatTime = (timestamp: number): string => {
  //       const date = new Date(timestamp);
  //       const day = date.getDate().toString().padStart(2, '0');
  //       const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //       const year = date.getFullYear();
  //       const hours = date.getHours();
  //       const minutes = date.getMinutes().toString().padStart(2, '0');
  //       const period = hours >= 12 ? 'PM' : 'AM';
  //       const hour12 = hours % 12 || 12; // Convert 24-hour to 12-hour format
  //       return `${day}-${month}-${year} ${hour12}:${minutes} ${period}`;
  //   };

  //   const formatDate = (timestamp: number): string => {
  //       const date = new Date(timestamp);
  //       const day = date.getDate().toString().padStart(2, '0');
  //       const month = (date.getMonth() + 1).toString().padStart(2, '0');
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //   };

  //   const parseDate = (dateString: string): Date => {
  //       // Parse date from DD-MM-YYYY format to a Date object
  //       const [day, month, year] = dateString.split('-').map((part: string) => parseInt(part, 10));
  //       return new Date(year, month - 1, day); // month is 0-indexed in JavaScript
  //   };

  //   // Format and sort activity data
  //   const formattedData = activityData.map(activity => {
  //       // Format g_creation_time to DD-MM-YYYY HH:mm AM/PM format
  //       const activity_g_creation_time = formatTime(activity.g_creation_time);

  //       // Format start_time to DD-MM-YYYY HH:mm AM/PM format
  //       const activity_start_time = formatTime(activity.start_time);

  //       // Format end_time to YYYY-MM-DD HH:mm AM/PM format (24-hour format for end_time)
  //       const activity_end_time = formatTime(activity.end_time).replace(/^(\d{2}-\d{2}-\d{4}) (\d{1,2}):/, '$1 $2:');

  //       // Format start_time and end_time for the activity_start_date and activity_end_date
  //       const activity_start_date = formatDate(activity.start_time);
  //       const activity_end_date = formatDate(activity.end_time);

  //       // Calculate total_activity_time in hours
  //       const totalActivityTime = (activity.end_time - activity.start_time) / 3600000;

  //       // Return the formatted data
  //       return {
  //           activity_g_creation_time,  // Formatted g_creation_time
  //           activity_start_time,       // Formatted start_time
  //           activity_end_time,         // Formatted end_time
  //           activity_start_date,       // Formatted start_date (DD-MM-YYYY)
  //           activity_end_date,         // Formatted end_date (DD-MM-YYYY)
  //           total_activity_time: parseFloat(totalActivityTime.toFixed(2)), // rounding to 2 decimal places
  //           goal_value: activity.goal_value,
  //           goal_unit: activity.goal_unit,
  //           tracker_type: activity.tracker_type,
  //           g_creation_time: activity.g_creation_time,
  //           start_time: activity.start_time,
  //           end_time: activity.end_time
  //       };
  //   });

  //   // Sort the formatted data by activity_start_date in descending order
  //   return formattedData.sort((a, b) => {
  //       const dateA = parseDate(a.activity_start_date);
  //       const dateB = parseDate(b.activity_start_date);
  //       return dateB.getTime() - dateA.getTime(); // Descending order
  //   });
  // }

  // getActivityDataForRecentDate(activityData: any[]): any[] {
  //   // Step 1: Get the most recent activity_start_date from the first item
  //   const mostRecentDate = activityData[0].activity_start_date;
  //   // Step 2: Filter all entries that match the most recent date
  //   const activitiesForMostRecentDate = activityData.filter(activity => activity.activity_start_date === mostRecentDate);
  //   return activitiesForMostRecentDate;
  // }

  // filterDataByMostRecentGoalValue(data: any[]): any[] {
  //   // Step 1: Find the most recent entry
  //   const mostRecentEntry = data.reduce((prev, current) => {
  //       return (prev.g_creation_time > current.g_creation_time) ? prev : current;
  //   });

  //   // Step 2: Get the goal_value of the most recent entry
  //   const mostRecentGoalValue = mostRecentEntry.goal_value;

  //   // Step 3: Filter the data based on the goal_value of the most recent entry
  //   const filteredData = data.filter(entry => entry.goal_value === mostRecentGoalValue);

  //   return filteredData;
  // }

  // processFilteredData(filteredData: any[]): any {
  //   //Calculate the totalActivityTime (sum of total_activity_time from all filtered entries)
  //   const totalActivityTime = filteredData.reduce((total, entry) => total + entry.total_activity_time, 0);

  //   //Get the goal_value, goal_unit, and tracker_type from the first entry (assuming they are the same across entries)
  //   const goalValue = filteredData[0]?.goal_value; 
  //   const goalUnits = filteredData[0]?.goal_unit;  
  //   const trackerType = filteredData[0]?.tracker_type;
  //   const activityDate = filteredData[0]?.activity_start_date;

  //   //Calculate the goal_percentage
  //   const goalPercentage = goalValue > 0 ? (totalActivityTime / parseFloat(goalValue)) * 100 : 0;
  //   const roundedGoalPercentage = Math.round(goalPercentage * 100) / 100;
  //   const activity_date = moment(activityDate, 'DD-MM-YYYY').format('DD-MMM-YYYY');

  //   //Return the result object
  //   return {
  //       goal_value: goalValue,
  //       totalActivityTime,
  //       goal_percentage: roundedGoalPercentage,
  //       goal_units: goalUnits,
  //       tracker_type: trackerType,
  //       start_date: activity_date
  //   };
  // }

  // getVitals(data) {

  //   //logic to filter vitals & trackers
  //   let tracker_type:string = '';
  //   let vital_type:string = '';

  //   if(data.widget_sub_type){
      
  //       if(data.widget_sub_type=='bp' || data.widget_sub_type=='bsugar' || data.widget_sub_type=='bmiScore'){
  //         //vitals api
  //         if(data.widget_sub_type=='bp'){
  //           vital_type = 'systolic#diastolic';
  //         }
  //         else if(data.widget_sub_type=='bsugar'){
  //           vital_type = 'FBS#rbs';
  //         }
  //         else if(data.widget_sub_type=='bmiScore'){
  //           vital_type = 'BMI#weight#height';
  //         }

  //         let obj: any = { args: 'vitalType:' + vital_type + ',uhId:' + localStorage.getItem("hasUhId") + ',userId:' + this.authenticationService.getCurrentUser().user_id + ",cug_code:" + this.storage.getBgDetails().cug_code, order_by: 'g_creation_time desc',"page_no": 0, "page_size": 10 };
          
  //         this.baseService.getData(obj, '', "emr_vitals", "diagnostic", "GET_VITAL_DASHBOARD").subscribe(val => {
  //         // this.trackerReminderService.getVitalFeeddata(undefined,undefined,vital_type, 10).subscribe(val => {
  //         if (val) {
  //               this.loader.hideSpinner();
  //               let res = val;
  //               if (res.errCode == 0) {
  //                 if (res.resource.length > 0) {
  //                   let vitalsData = res.resource;
  //                   if(data.widget_sub_type == 'bp'){
  //                     const systolicData = vitalsData.filter(item => item.vitalType_id === 'systolic');
  //                     const diastolicData = vitalsData.filter(item => item.vitalType_id === 'diastolic');
  //                     let latestsystolicData = '';
  //                     let latestdiastolicData  = '';
  //                     let vitalUnit = '';
  //                     let vitalData = '';
  //                     if (systolicData && systolicData.length > 0) {
  //                         latestsystolicData = systolicData.length > 0 ? systolicData[0].value : null;
  //                     }
  //                     if (diastolicData && diastolicData.length > 0) {
  //                         latestdiastolicData = diastolicData.length > 0 ? diastolicData[0].value : null;
  //                         vitalUnit = diastolicData.length > 0 ? diastolicData[0].units : null;
  //                     }

  //                     if(latestsystolicData && latestdiastolicData){
  //                       vitalData = latestsystolicData + '/' + latestdiastolicData + '' + vitalUnit;
  //                     }
                      
  //                     this.setWidgetData(vitalData);
  //                   }

  //                   if(data.widget_sub_type == 'bsugar'){
  //                     const fbsData = vitalsData.filter(item => item.vitalType_id === 'FBS');
  //                     //const rbsData = vitalsData.filter(item => item.vitalType_id === 'rbs');
  //                     console.log('vitalsss data', fbsData);
  //                     let latestfbsData = '';
  //                     let latestrbsData  = '';
  //                     let vitalUnit = '';
  //                     let vitalData = '';

  //                     if (fbsData && fbsData.length > 0) {
  //                       latestfbsData = fbsData.length > 0 ? fbsData[0].value : null;
  //                       vitalUnit = fbsData.length > 0 ? fbsData[0].units : null;
  //                     }
  //                     // if (rbsData && rbsData.length > 0) {
  //                     //   latestrbsData = rbsData.length > 0 ? rbsData[0].value : null;
  //                     //   vitalUnit = rbsData.length > 0 ? rbsData[0].units : null;
  //                     // }

  //                     if(latestfbsData){
  //                       vitalData = latestfbsData + ' ' + vitalUnit;
  //                     }

  //                     this.setWidgetData(vitalData);
  //                   }

  //                   if(data.widget_sub_type == 'bmiScore'){
  //                     const bmiData = vitalsData.filter(item => item.vitalType_id === 'BMI');
                      
  //                     let latestbmiData = '';
  //                     let vitalUnit = '';
  //                     let vitalData = '';

  //                     if (bmiData && bmiData.length > 0) {
  //                       latestbmiData = bmiData.length > 0 ? bmiData[0].value : null;
  //                       vitalUnit = bmiData.length > 0 ? bmiData[0].units : null;

  //                       vitalData = latestbmiData + ' ' + vitalUnit;
  //                     }

  //                     this.setWidgetData(vitalData);
  //                   }
  //                 }
  //             }
      
  //           }
  //         })
  //       }
  //       else if(data.widget_sub_type=='sleep' || data.widget_sub_type=='yoga' || data.widget_sub_type=='exercise' || data.widget_sub_type=='meditation'){
  //         //tracker api
  //         if(data.widget_sub_type=='sleep'){
  //           tracker_type = '#sleep';
  //         }
  //         else if(data.widget_sub_type=='yoga'){
  //           tracker_type = '#yoga';
  //         }
  //         else if(data.widget_sub_type=='exercise'){
  //           tracker_type = '#exercise';
  //         }
  //         else if(data.widget_sub_type=='meditation'){
  //           tracker_type = '#meditation';
  //         }


  //         let obj: any = { args: 'tracker_type:' + tracker_type + ',uhId:' + localStorage.getItem('hasUhId') + ',patientId:' + this.authenticationService.getCurrentUser().user_id + ",cug_code:" + this.storage.getBgDetails().cug_code, order_by: 'g_creation_time desc' };
  //         this.baseService.getData(obj, '', "tracker_record", "diagnostic", "GET_PERSONAL_DASHBOARD").subscribe(resp => {
  //             if(resp){
  //               this.loader.hideSpinner();
  //               if (resp.errCode == 0) {
  //                 if (resp.resource.length > 0) {
  //                   let tracker_data = resp.resource;
                    
  //                   if(data.widget_sub_type == 'sleep'){
  //                     const sleepData = tracker_data.filter(item => item.tracker_type === 'sleep');
  //                     console.log('trackerr sleep: ',sleepData);
  //                     if (sleepData && sleepData.length > 0) {
  //                       let vitalData = '';
  //                       const sleepActivityData = this.formatActivityData(sleepData);
  //                       console.log('sleepData:', sleepActivityData);
  //                       const latestSleepActivityData = this.getActivityDataForRecentDate(sleepActivityData);
  //                       console.log('latestSleepData:', latestSleepActivityData);
            
  //                       if(latestSleepActivityData && latestSleepActivityData.length>0){
  //                         const finalSleepData =  this.filterDataByMostRecentGoalValue(latestSleepActivityData);
  //                         console.log('filteredSleepData:',finalSleepData );
  //                         const sleepDataFinal = this.processFilteredData(finalSleepData);
  //                         console.log('finalData', sleepDataFinal);
            
  //                         // this.sleep_record = {};
  //                         // this.sleep_record['goal_value'] = sleepDataFinal.goal_value;
  //                         // this.sleep_record['spent_hrs'] = sleepDataFinal.totalActivityTime;
  //                         // this.sleep_record['latest_date'] = sleepDataFinal.start_date;
  //                         vitalData = sleepDataFinal.totalActivityTime +" "+sleepDataFinal.goal_units;
  //                         this.setWidgetData(vitalData);
  //                       }
  //                     }
  //                     else {
  //                       this.sleep_record = {};
  //                     }
  //                   }

  //                   if(data.widget_sub_type == 'yoga'){
  //                     const yogaData = tracker_data.filter(item => item.tracker_type === 'yoga');
  //                     if (yogaData && yogaData.length > 0) {
  //                       let vitalData = '';
  //                       const yogaActivityData = this.formatActivityData(yogaData);
  //                       console.log('yogaData', yogaActivityData);
  //                       const latestYogaActivityData = this.getActivityDataForRecentDate(yogaActivityData);
  //                       console.log('latestYogaData', latestYogaActivityData);
                        
  //                       if(latestYogaActivityData && latestYogaActivityData.length>0){
  //                         const finalyogaData =  this.filterDataByMostRecentGoalValue(latestYogaActivityData);
  //                         console.log('filteredYogaData: ',finalyogaData );
  //                         const yogaDataFinal = this.processFilteredData(finalyogaData);
  //                         console.log('finalData', yogaDataFinal);

  //                         vitalData = yogaDataFinal.totalActivityTime +" "+ yogaDataFinal.goal_units;
  //                         this.setWidgetData(vitalData);
            
  //                         // this.yoga_record = {};
  //                         // this.yoga_record['goal_value'] = yogaDataFinal.goal_value;
  //                         // this.yoga_record['spent_hrs'] = yogaDataFinal.totalActivityTime;
  //                         // this.yoga_record['latest_date'] = yogaDataFinal.start_date;
  //                         // let percentage_val = yogaDataFinal.goal_percentage;
  //                         // if (percentage_val > 100)
  //                         //   percentage_val = 100
  //                         // this.drawRingforPH(percentage_val, 'yoga');
  //                       }
  //                     }
  //                     else {
  //                       this.yoga_record = {};
  //                     }
  //                   }

  //                   if(data.widget_sub_type == 'exercise'){
  //                     const exerciseData = tracker_data.filter(item => item.tracker_type === 'exercise');
  //                     if (exerciseData && exerciseData.length > 0) {
  //                       let vitalData = '';
  //                       const exerciseActivityData = this.formatActivityData(exerciseData);
  //                       console.log('exerciseData', exerciseActivityData);
  //                       const latestExerciseActivityData = this.getActivityDataForRecentDate(exerciseActivityData);
  //                       console.log('latestExerciseData', latestExerciseActivityData);
                       
            
  //                       if(latestExerciseActivityData && latestExerciseActivityData.length>0){
  //                         const finalExerciseData =  this.filterDataByMostRecentGoalValue(latestExerciseActivityData);
  //                         console.log('filteredExercise data: ',finalExerciseData);
  //                         const ExerciseDataFinal = this.processFilteredData(finalExerciseData);
  //                         console.log('finalData', ExerciseDataFinal);
                          
  //                         vitalData = ExerciseDataFinal.totalActivityTime +" "+ ExerciseDataFinal.goal_units;
  //                         this.setWidgetData(vitalData);
  //                         // this.exercise_record = {};
  //                         // this.exercise_record['goal_value'] = ExerciseDataFinal.goal_value;
  //                         // this.exercise_record['spent_hrs'] = ExerciseDataFinal.totalActivityTime;
  //                         // this.exercise_record['latest_date'] = ExerciseDataFinal.start_date;
  //                         // let percentage_val = ExerciseDataFinal.goal_percentage;
  //                         // if (percentage_val > 100)
  //                         //   percentage_val = 100
  //                         // this.drawRingforPH(percentage_val, 'exercise');
  //                       }
  //                     }
  //                     else {
  //                       this.exercise_record = {};
  //                     }
  //                   }

  //                   if(data.widget_sub_type == 'meditation'){
  //                     const meditationData = tracker_data.filter(item => item.tracker_type === 'meditation');
  //                     if (meditationData && meditationData.length > 0) {
  //                       let vitalData = '';
  //                       const medActivityData = this.formatActivityData(meditationData);
  //                       console.log('meditationData', medActivityData);
  //                       const latestMedActivityData = this.getActivityDataForRecentDate(medActivityData);
  //                       console.log('latestMedData', latestMedActivityData);
            
  //                       if(latestMedActivityData && latestMedActivityData.length>0){
  //                         const finalMedData =  this.filterDataByMostRecentGoalValue(latestMedActivityData);
  //                         console.log('filteredMeditationdata: ',finalMedData );
  //                         const MedDataFinal = this.processFilteredData(finalMedData);
  //                         console.log('finalData', MedDataFinal);

  //                         vitalData = MedDataFinal.totalActivityTime +" "+ MedDataFinal.goal_units;
  //                         this.setWidgetData(vitalData);
            
  //                         // this.meditation_record = {};
  //                         // this.meditation_record['goal_value'] = MedDataFinal.goal_value;
  //                         // this.meditation_record['spent_hrs'] = MedDataFinal.totalActivityTime;
  //                         // this.meditation_record['latest_date'] = MedDataFinal.start_date;
  //                         // let percentage_val = MedDataFinal.goal_percentage;
  //                         // if (percentage_val > 100)
  //                         //   percentage_val = 100
  //                         // this.drawRingforPH(percentage_val, 'meditation');
  //                       }
  //                     }
  //                     else {
  //                       this.meditation_record = {};
  //                     }
  //                   }

  //                 }
  //               }
  //             }
  //         });
  //       }
  //   }

  //   return
  //   let obj = { filter: 'userId:' + this.authenticationService.getCurrentUser().user_id + ",uhId:" + localStorage.getItem("hasUhId") + ",cug_code:" + this.appservice != undefined && this.appservice._currentSessionData != undefined && this.appservice._currentSessionData.cug_code != undefined ? this.appservice._currentSessionData.cug_code : '' };
  //   this.baseService.getData(obj, '', "emr_vitals", "diagnostic", "GET_ALL").subscribe(val => {
  //     if (val) {
  //       {
  //         this.loader.hideSpinner();
  //         let res = val;
  //         if (res.errCode == 0) {
  //           if (res.resource.length > 0) {
  //             let bpdata: Array<any> = res.resource;
  //             for (let index = 0; index < bpdata.length; index++) {
  //               let vitalname: Array<any> = bpdata[index].vitalsName;
  //               //let vital = this.setVitals(vitalname, data);
  //               // if (vital != undefined) {
  //               //   break;
  //               // }
  //             }
  //           }
  //         }
  //       }

  //     }
  //   })
  // }

  setWidgetData(vitalData){
    if(vitalData){
      return this.vitalVal = vitalData;
    }
  }
  // setVitals(vitalname, WidgetData) {
  //   try {
  //     if (WidgetData.widget_sub_type == 'bp') {
  //       let systolic_data = vitalname.find(x => x.vitalType_id == 'systolic');
  //       let diastolic_data = vitalname.find(x => x.vitalType_id == 'diastolic');
  //       if (systolic_data != undefined && diastolic_data != undefined) {
  //         return this.vitalVal = diastolic_data.value + '/' + systolic_data.value + ' ' + systolic_data.units;
  //       }
  //     }
  //     else if (WidgetData.widget_sub_type == 'bsugar') {
  //       let fbs_data = vitalname.find(x => x.vitalType_id == 'fbs');
  //       if (fbs_data != undefined) {
  //         return this.vitalVal = fbs_data.value + ' ' + fbs_data.units;
  //       }
  //     }
  //     else if (WidgetData.widget_sub_type == 'bmiScore') {
  //       let bmi_data = vitalname.find(x => x.vitalType_id == 'bmi');
  //       if (bmi_data != undefined) {
  //         return this.vitalVal = bmi_data.value + ' ' + bmi_data.units;
  //       }
  //     }
  //   } catch (error) { }
  // }

}
